import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { EditLocalAdsComponent } from 'app/components/edit-local-ads/edit-local-ads.component';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-manage-local-ads',
  templateUrl: './manage-local-ads.component.html',
  styleUrls: ['./manage-local-ads.component.css']
})
export class ManageLocalAdsComponent implements OnInit {

  advertisements = []

  constructor(private adminService: DataService, private dialog: MatDialog, private notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.adminService.getLocalAd().subscribe(data => {
      if(data.status){
        let advertisements = data.localAds
        if(advertisements.length){
          for(let ad of advertisements){
            ad['imagePath'] = environment.api + '/images/' + ad['imagePath']
            this.advertisements.push(ad)
          }
        }  
      }
    })
  }

  addLocalAd(){
    const dialogRef = this.dialog.open(EditLocalAdsComponent, {
      width: '80%',
      height: 'auto',
      data: {
        link: '',
        imagePath: '',
        locationOfAd: '',
        page: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.adminService.addLocalAd(result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            data.localAd.imagePath = environment.api + '/images/' + data.localAd.imagePath
            this.advertisements.push(data.localAd)
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  updateLocalAd(ad){
    const dialogRef = this.dialog.open(EditLocalAdsComponent, {
      width: '80%',
      height: 'auto',
      data: {
        link: ad.link,
        imagePath: ad.imagePath,
        locationOfAd: ad.locationOfAd,
        page: ad.page
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if( typeof(result.imagePath) == 'string'){
            delete result['imagePath']
        }
        this.adminService.editLocalAd(ad.id, result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            data.localAd.imagePath = environment.api + '/images/' + data.localAd.imagePath
            this.advertisements[this.advertisements.indexOf(ad)] = data.localAd
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg , 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  deleteLocalAd(ad){
    let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to delete this item?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.adminService.deleteLocalAd(ad.id).subscribe(data => {
          if(data.status){
            let index = this.advertisements.indexOf(ad)
            this.advertisements.splice(index, 1)
            this.openNotification('Local Adverisement has been deleted!')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

}
